import { Component, inject } from "@angular/core";
import { DashboardWidgetType } from "@app/dashboard/shared/enums/DashboardWidgetType.enum";
import { QuickLinkItemContent } from "@app/dashboard/shared/enums/QuickLinkItemContent.enum";
import { DashboardQuickLinkModel } from "@app/dashboard/shared/models/DashboardQuickLinkModel";
import { Pages } from "@constants/pages/Pages";
import { PermissionsService } from "@services/permissions/PermissionsService";
import { TabService } from "@services/tabs/TabService";
import { ILinkWidgetGeneratorType } from "./../../shared/interfaces/ILinkWidgetGeneratorType";
import { BaseWidget } from "./../BaseWidget";
import { AdminLinkGenerator } from "./link-types/AdminLinkGenerator";
import { AuditLinkGenerator } from "./link-types/AuditLinkGenerator";
import { InsightsLinkGenerator } from "./link-types/InsightsLinkGenerator";
import { ModuleOverviewLinkGenerator } from "./link-types/ModuleOverviewLinkGenerator";
import { NavigatorLinkGenerator } from "./link-types/NavigatorLinkGenerator";
import { MicroservicePermissionService } from "@services/permissions/permissions.service";
import { injectTranslation, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/dashboard/i18n/scope";

@Component({
    selector: "link-widget",
    templateUrl: "./link-widget.component.html",
    styleUrls: ["./link-widget.component.scss"],
    viewProviders: [provideTranslationScope(scope)],
})
export class LinkWidgetComponent extends BaseWidget {
    private _tabService = inject(TabService);
    private _pages = inject(Pages);
    private _permissions = inject(PermissionsService);
    private _translation = injectTranslation(scope);

    private microsevicePermissionService: MicroservicePermissionService = inject(
        MicroservicePermissionService
    );

    quickLinks: DashboardQuickLinkModel[];
    contentType = QuickLinkItemContent;

    async load() {
        await this.initAvailableTypes();
        super.load();
    }

    openPage(page: string) {
        this._tabService.generateTab(page);
    }

    private async initAvailableTypes() {
        let type: ILinkWidgetGeneratorType;
        switch (this.config.customConfig.type) {
            case DashboardWidgetType.AdminPanel:
                type = new AdminLinkGenerator();
                break;
            case DashboardWidgetType.Insights:
                type = new InsightsLinkGenerator();
                break;
            case DashboardWidgetType.ModuleOverview:
                type = new ModuleOverviewLinkGenerator(this.microsevicePermissionService);
                break;
            case DashboardWidgetType.Navigators:
                type = new NavigatorLinkGenerator();
                break;
            case DashboardWidgetType.AuditOverview:
                type = new AuditLinkGenerator();
                break;
        }

        this.quickLinks = type.getTypes(this._permissions.permissions, this._pages);

        // The generators emit dashboard scope keys for their static labels.
        await this._translation.ready();
        this.quickLinks.forEach((link) => {
            link.title = this._translation.t(link.title);
            if (link.description) {
                link.description = this._translation.t(link.description);
            }

            link._datauiid = "dashboard-link-" + link.title.replace(/\s+/g, "-").toLowerCase();
        });
    }
}
